module.exports = __webpack_public_path__ + "static/media/TBU.6772ac88.webp";